import setting from "./setting"
import ls from "./ls.js"

export default function (url, option = {}, method = 'GET', body = null) {
    const options = Object.assign({
        method,
        mode: 'cors'
    }, option)
    const token = ls.get('token_id')
    if (token) {
        if (options.headers) {
            options.headers.Authorization = 'Token ' + token
        } else {
            options.headers = {
                Authorization: 'Token ' + token
            }
        }
    }
    if (body) {
        options.body = body
    }
    return window.fetch(setting.apiURL + url, options).then(async r => {
        if (r.ok) {
            const ct = r.headers.get('content-type')
            if (ct && ct.startsWith('application/json')) {
                const json = await r.json()
                return ({json, status: r.status, headers: r.headers})
            } else {
                const text = await r.text()
                return ({text, json: null, status: r.status, headers: r.headers})
            }
        } else {
            if (r.status !== 404) {
                const ct = r.headers.get('content-type')
                if (ct && ct.startsWith('application/json')) {
                    const json = await r.json()
                    json.status = r.status
                    throw new Error(json.message, json.error)
                }
                throw new Error(r.statusText)
            }
            return {
                json: null,
                text: null,
                status: r.status,
                headers: r.headers
            }
        }
    })
}
